import Footer from "../components/Footer";
import Heading from "../components/Heading";
import classNames from "classnames/bind";
import Layout from "../components/Layout";
import styles from "./VenturesPage.module.css";
import gridStyle from "../components/Grid.module.css";
import buttonStyle from "../components/Button.module.css";
import enquiryStyle from "../components/EnquiryForm.module.css";
import ProjectList from "../components/ProjectList";
import TestimonialList from "../components/TestimonialList";
import ExpandableSection from "../components/ExpandableSection";
import EnquiryForm from "../components/EnquiryForm";
import { scrollIntoView } from "seamless-scroll-polyfill";

function Section({ heading, children, className, id }) {
  return (
    <div
      className={classNames(styles.contentSection, gridStyle.grid, className)}
      id={id}
    >
      <p className={styles.subheading}>{heading}</p>
      {children}
    </div>
  );
}

export default function VenturesPage({ coreData, pageData, pathName }) {
  return (
    <Layout coreData={coreData} theme="light" pathName={pathName}>
      <div className={classNames(styles.introSection, gridStyle.grid)}>
        <Heading className={styles.introHeading}>{pageData.heading}</Heading>
      </div>
      <Section heading="About">
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: pageData.introText }}
        />
      </Section>
      <Section heading="Areas of support">
        <div className={styles.expandableSectionWrapper}>
          <div
            className={styles.expandableSectionIntroText}
            dangerouslySetInnerHTML={{ __html: pageData.supportAreasText }}
          />
          {pageData.supportAreaItems.map((item, index) => (
            <ExpandableSection
              key={index}
              heading={item.heading}
              text={item.body}
              isOpenByDefault={index === 0}
            />
          ))}
          <button
            className={classNames(styles.cta, buttonStyle.button)}
            onClick={() => {
              scrollIntoView(
                document.getElementById("enquiry-form"),
                {
                  behavior: "smooth",
                },
                {
                  duration: 600,
                },
              );
            }}
          >
            Get in touch about your idea
          </button>
        </div>
      </Section>
      <Section heading="External services">
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: pageData.externalServicesText }}
        />
      </Section>
      <div className={styles.projectListSection}>
        <p className={styles.projectListHeading}>Projects</p>
        <ProjectList
          projectPages={pageData.projectListItems}
          className={styles.projectList}
          imageBackgroundColor="var(--off-light)"
        />
      </div>
      <div
        className={classNames(
          styles.contentSection,
          gridStyle.grid,
          styles.testimonialsSection,
        )}
      >
        <p className={styles.subheading}>A few thoughts from our partners.</p>
        <TestimonialList testimonials={pageData.testimonialItems} />
      </div>
      <Section
        heading="Ready to begin?"
        className={enquiryStyle.formWrapper}
        id="enquiry-form"
      >
        <div className={styles.expandableSectionWrapper}>
          <EnquiryForm />
        </div>
      </Section>
      <div className={styles.footer}>
        <Footer theme="dark" />
      </div>
    </Layout>
  );
}
